module.exports = __webpack_public_path__ + "static/eric-davis-9dc7d351ce647b3ec2c25bf704d3a6fd.jpeg";